// @ts-nocheck
/* eslint-disable func-names */
// LIBRARY
import React from 'react';
import { Row, Col, Input, Table, Drawer, Icon, Button, Tag } from 'antd';

// CUSTOM MODULES
// import HttpCodeMessage from 'shared_components/message_http_status';
import { UserAccessContext } from 'context/userAccess';
import { panelListAPI, applyPanelSorting, getPanelInfoAPI } from 'services/settings/panelExamRequesting';	
import PanelForm from '../panel_form'
import DownloadCSV from 'shared_components/download_csv';
import TablePager from 'shared_components/table_pager';
import SearchPatientTableHeader from '../table_header';
import { DndProvider } from 'react-dnd';
import HTML5Backend from 'react-dnd-html5-backend';
import update from 'immutability-helper';
import DragableBodyRow from './drag_and_drop';
import { showMessage } from 'services/settings/message';

import { drawerUpdateTitle, drawerAddTitle, tablePageSize, tableSize, buttonLabels } from '../settings';

// CSS
import './paneltable.css';

// CONSTANTS
const { Search } = Input;

const columns = [
    {
			title: 'PANEL EXAM NAME',
			dataIndex: 'panel_name',
			key: 'panel_name',
			sorter: (a, b) => (a.panel_name || "").localeCompare(b.panel_name || "")
    },
    {
			title: 'PANEL EXAM CODE',
			dataIndex: 'code',
			key: 'code',
			width: 200,
			sorter: (a, b) => (a.code || "").localeCompare(b.code || "")
    },
    {   
			title: 'INTEGRATION CODE',
			dataIndex: 'integration_code',
			key: 'integration_code',
			width: 250,
			sorter: (a, b) => (a.integration_code || "").localeCompare(b.integration_code || "")
    },
	// {
	// 	title: 'STATUS',
	// 	dataIndex: 'status',
	// 	key: 'status',
	// 	width: 200
	// }
	{ 
		title: 'STATUS',
		dataIndex: 'status',
		width: 100,
		render: status => (
			<Tag color={status === 0 ? "red" : "green"}>
				{status === 0 ? 'INACTIVE' : 'ACTIVE'}
			</Tag>
		)
	}
]

class PanelTable extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			isDrawerVisible: false,
			drawerTitle: '',
			drawerButton: '',
			loading: false,
			panelInfo: {},
			panelListRef: [],
			panelListState: [],
			pagination: {
				current: 1,
				pageSize: tablePageSize,
			},
			searchTerm: '',
		}

		this.components = {
			body: {
				row: DragableBodyRow,
			},
		};
	}

	componentDidMount() {
		this.populatePanelList();
	}

	formatPanelData = (data) => {
		return (data || []).map((panel, index) => ({
			key: `panel-${panel.panelRequestID}-${index}`,
			panelRequestID: panel.panelRequestID,
			code: panel.panelRequestCode,
			panel_name: panel.panelRequestName,
			integration_code: panel.panelRequestIntegrationCode,
			status: panel.panelRequestActive,
			sort: panel.panelRequestSort
		}));
	}

	populatePanelList = async () => {
		this.setState({ loading: true });
		try {
			const { data } = await panelListAPI();
			if (data) {
				const panelList = this.formatPanelData(data)
					.sort((a, b) => {
						const sortDiff = (a.sort || 0) - (b.sort || 0);
						if (sortDiff !== 0) return sortDiff;
						return (a.panelRequestID || 0) - (b.panelRequestID || 0);
					});

				this.setState({
					panelListState: panelList,
					panelListRef: panelList,
				});
			}
		} catch (error) {
			console.error("Error fetching panels:", error);
		} finally {
			this.setState({ loading: false });
		}
	}

	displayDrawerUpdate = (record) => {
		this.setState({
			isDrawerVisible: true,
			drawerTitle: drawerUpdateTitle,
			drawerButton: buttonLabels.update,
			panelInfo: record
		});
	}

	onClose = () => {
		this.setState({ isDrawerVisible: false });
	};

	onSuccess = () => {
		this.setState({ isDrawerVisible: false }, this.populatePanelList);
	};

	onSearch = (value) => {
		const { panelListRef, pagination } = this.state;
		const searchValue = (value || "").toLowerCase().trim();

		const filtered = panelListRef.filter(item => 
			(item.panel_name || "").toLowerCase().includes(searchValue) ||
			(item.code || "").toLowerCase().includes(searchValue)
		);

		// Show "No record found" message if no results
		if (filtered.length === 0 && searchValue !== '') {
			showMessage('M0001');
		}

		this.setState({ 
			panelListState: filtered,
			pagination: { ...pagination, current: 1 },
			searchTerm: searchValue
		});
	}

	onChangeSearch = (event) => {
		const { value } = event.target;
		if (value === '') {
			this.setState(prevState => ({ 
				panelListState: prevState.panelListRef,
				pagination: { ...prevState.pagination, current: 1 },
				searchTerm: ''
			}));
		} else {
			this.setState({ searchTerm: value });
		}
	}

	moveRow = (dragIndex, hoverIndex) => {
		const { panelListState, pagination } = this.state;
		const offset = (pagination.current - 1) * pagination.pageSize;

		const globalDragIndex = dragIndex + offset;
		const globalHoverIndex = hoverIndex + offset;

		const dragRow = panelListState[globalDragIndex];
		if (!dragRow) return;

		const updatedData = update(panelListState, {
			$splice: [
				[globalDragIndex, 1],
				[globalHoverIndex, 0, dragRow],
			],
		});

		this.setState({ panelListState: updatedData });
	};

	applySort = async () => {
		const { panelListState } = this.state;
		const dataPayload = panelListState.map((rec, index) => ({
			panelRequestID: rec.panelRequestID,
			panelRequestSort: index + 1,
		}));

		this.setState({ loading: true });
		const sortResponse = await applyPanelSorting(dataPayload);
		if (sortResponse && sortResponse.status === 200) {
			showMessage('M0006');
			this.populatePanelList();
		} else {
			this.setState({ loading: false });
		}
	};

	handleTableChange = (pagination) => {
		this.setState({ pagination });
	}

	handlePanelExport = async () => {
		const { panelListRef } = this.state;
		return panelListRef;
	}

	showDrawer = () => {
		this.setState({
			isDrawerVisible: true,
			drawerTitle: drawerAddTitle,
			drawerButton: buttonLabels.create,
			panelInfo: {},
		});
	}

	handleChangeSize = (pageSize) => {
		this.setState(prevState => ({ 
			pagination: { 
				...prevState.pagination, 
				pageSize: parseInt(pageSize),
				current: 1 
			} 
		}));
	} 

	render() {
		const { panelListState, panelListRef, pagination, loading, isDrawerVisible, drawerTitle, panelInfo, drawerButton } = this.state;

		return (
			<div className="panel-table-container">
				<div className="panel-table-options">
					<Row gutter={[16, 16]} align="middle">
						<Col xs={24} md={12}>
							<Search
								allowClear
								onSearch={this.onSearch}
								onChange={this.onChangeSearch}
								style={{ width: '100%', maxWidth: 300 }}
								className="panel-table-search-input"
								placeholder='PANEL EXAM NAME'
							/>
						</Col>
						<Col xs={24} md={12} style={{ textAlign: 'right' }}>
						<Button 
								type="primary" 
								shape="round" 
								onClick={this.applySort}
								loading={loading}
								icon={<Icon type="save" />}
								style={{ marginRight: 8 }} 
							>
								APPLY SORTING
							</Button>
							<DownloadCSV
								confirmRequired={true}
								isLookupTable={true}
								filename="panel_exam"
								confirmDetails={{
									title: 'PANEL EXAM',
									section: 'PANEL EXAM',
									count: (panelListRef || []).length,
								}}
								onConfirm={this.handlePanelExport}
								data={panelListRef} // Fallback data
								disabled={loading || (panelListRef || []).length === 0}
								columns={[
									{ title: 'PANEL EXAM NAME', dataIndex: 'panel_name' },
									{ title: 'PANEL EXAM CODE', dataIndex: 'code' },
									{ title: 'INTEGRATION CODE', dataIndex: 'integration_code' },
									{ 
										title: 'STATUS', 
										dataIndex: 'status',
										render: status => status === 0 ? 'INACTIVE' : 'ACTIVE'
									}
								]}
							/>
							<UserAccessContext.Consumer>
								{value => (value.userAccess && value.userAccess.settings && value.userAccess.settings.create) && (
									<Button 
										type="primary" 
										shape="round" 
										
										onClick={this.showDrawer}
									>
										<Icon type="plus" />
										{drawerAddTitle}
									</Button>
								)}
							</UserAccessContext.Consumer>
							
						</Col>
					</Row>
					<SearchPatientTableHeader 
						pageSize={pagination.pageSize}
						pageTotal={panelListState.length} 
						handleChangeSize={this.handleChangeSize}
						currentPage={pagination.current}
					/>
				</div>
				<DndProvider backend={HTML5Backend}>
					<Table 
						className="settings-panel-exam-table"
						size={tableSize}
						dataSource={panelListState}
						pagination={{ ...pagination, showSizeChanger: false }}
						onChange={this.handleTableChange}
						loading={loading} 
						columns={columns}
						components={this.components}
						rowKey={(record, index) => (record && record.key) || index}
						onRow={(record, index) => {
							if (!record) return {};
							return {
								index,
								moveRow: this.moveRow,
								onDoubleClick: () => this.displayDrawerUpdate(record)
							};
						}}
					/>
				</DndProvider>
				
				<Drawer 
					title={drawerTitle}
					visible={isDrawerVisible}
					onClose={this.onClose}
					width="60%"
					destroyOnClose
				>
					<PanelForm
						drawerButton={drawerButton}
						panelInfo={panelInfo}
						onCancel={this.onClose}
						onSuccess={this.onSuccess}
						maxSort={Math.max(0, ...panelListRef.map(p => p.sort || 0))}
						panelList={panelListRef}
					/>
				</Drawer>
			</div>
		);
	}
}

export default PanelTable;